import PageComponent from '@gameday/common/components/form/Pages/Success'
import { useEffect } from 'react'
import { convertFormType } from '../../../../utils/common'

const SuccessComponent = ({
  formType,
  user,
  formSettings,
  registeredTeam,
  registrations,
  isTeamEvent,
  teamFormType,
  getTeamLogo,
  teamLogo,
  orderId,
  orderStatus,
  getOrderStatus,
  startTimer,
  formInfo,
  ...rest
}) => {
  useEffect(() => {
    const { teamDetails } = registeredTeam || {}
    // eslint-disable-next-line no-shadow
    const { logo, teamLogo } = teamDetails || {}
    const logoImage = logo || teamLogo
    if (logoImage) {
      getTeamLogo(logoImage)
    }
    startTimer(false)
  }, [])

  useEffect(() => {
    getOrderStatus({ orderId })
  }, [orderId])

  const { eventType, generateEventTicket, generateEventEntryPass, guestRegistration } = formSettings
  const isTeamRego = isTeamEvent && teamFormType === 'Register A Team'
  const type = convertFormType(formType) || convertFormType(formInfo?.form?.type)
  const isGuest = !user?.firstName && guestRegistration

  let additionalText = ''

  if (formType === 'event' && eventType) {
    if (eventType.toLowerCase() === 'ticketing' && generateEventTicket) {
      additionalText = `Printable PDF tickets will be attached to the above order payment confirmation email. ${
        isGuest
          ? 'Tickets are also available via the GameDay App for orders linked to an account.'
          : 'Tickets are also available via the GameDay App.'
      }`
    } else if (eventType.toLowerCase() === 'event entry' && (generateEventTicket || generateEventEntryPass)) {
      additionalText =
        'Applicable printable PDF passes/tickets will be attached to the above order payment confirmation email. Passes/tickets are also available via the GameDay App.'
    }
  }

  const { gatewayReference, paymentMethod, paymentType, date } = orderStatus || {}

  const paymentAmount = orderStatus ? orderStatus.amountFormatted : null

  const successEmailMessage = (
    <>
      You will receive a copy of the payment receipt via email{' '}
      {user.email ? (
        <span>
          to <strong>{user.email}</strong>
        </span>
      ) : (
        'via email'
      )}{' '}
      {paymentType === 'direct_debit' &&
        'following successful debit of your account (this may take up to 3 business days).'}
    </>
  )

  const directDebitSuccessProps =
    paymentType === 'direct_debit'
      ? {
          paymentSuccessHeading: `Thanks for your ${
            formType?.toLowerCase() === 'shop' ? 'purchase' : 'registration'
          } and direct debit payment request`,
          orderStatus: { ...orderStatus, status: 'Processing' },
        }
      : {}

  return (
    <PageComponent
      orderId={orderId}
      orderStatus={orderStatus}
      paymentSuccessMessage={
        <>
          <p>{successEmailMessage}</p>
          {type === 'event' && additionalText && <p>{additionalText}</p>}
        </>
      }
      successMessage={
        <>
          <p>
            Your {type?.toLowerCase() === 'shop' ? 'purchase' : 'registration'} has been submitted.
            {successEmailMessage}
          </p>
          {type === 'event' && additionalText && <p>{additionalText}</p>}
        </>
      }
      formSettings={formSettings}
      formType={type}
      user={user}
      isTeamEvent={isTeamEvent}
      isTeamRego={isTeamRego}
      teamData={registeredTeam}
      registrations={registrations}
      teamLogo={teamLogo}
      gatewayReference={gatewayReference}
      paymentDate={date}
      paymentAmount={paymentAmount}
      paymentMethodDescription={paymentMethod}
      getOrderStatus={getOrderStatus}
      {...rest}
      {...directDebitSuccessProps}
    />
  )
}

export default SuccessComponent
